import { useFlags } from "@/utils/flagsmith/useFlags";
import { useApiQuery } from "@/api/hooks/useApiQuery";
import { DetailTableRow } from "../../components/DetailTable";
import { DataSource, useColorizedValue } from "../useColorizedValue";
import {
    FinanceLabFieldType,
    formatFinanceLabValue,
} from "@/entities/FinanceLab";
import { COMING_SOON } from "@/entities/CreditBox/CreditBox.types";
import { getCompany } from "@/entities/Company/Company.queries";

export function useCapitalStructureData(): DetailTableRow[] {
    const flags = useFlags();
    const showPreAlphaFields = flags.enabled("show-pre-alpha-fields");
    const showComingSoonFields = flags.enabled("show-coming-soon-placeholders");

    const company = useApiQuery(getCompany);

    const totalEquityRaised = company.data?.capitalApplication.equityRaised;

    const totalEquityRaisedColorized = useColorizedValue(
        formatFinanceLabValue(
            totalEquityRaised,
            FinanceLabFieldType.CURRENCY,
        ) || "-",
        DataSource.LEGACY_BACKEND,
        "company.capitalApplication.equityRaised",
    );

    return [
        ...(showComingSoonFields
            ? [
                  {
                      label: "Senior Debt",
                      value: COMING_SOON,
                  },
              ]
            : []),
        ...(showPreAlphaFields
            ? [
                  {
                      label: "Total Equity Raised",
                      value: totalEquityRaisedColorized.value,
                      valueClassName: totalEquityRaisedColorized.className,
                      source: totalEquityRaisedColorized.source,
                      sourceClassName:
                          totalEquityRaisedColorized.sourceClassName,
                      onClick: () => {},
                  },
              ]
            : []),
        ...(showComingSoonFields
            ? [
                  {
                      label: "Junior Debt",
                      value: COMING_SOON,
                  },
              ]
            : []),
    ];
}
